import { hasRoleClaim, type JwtClaims } from "@pgs-core/portal-lib/claims";

export * from "@pgs-core/portal-lib/claims";

export function hasTenantRoleClaim(claims: JwtClaims): boolean {
  return hasRoleClaim(claims, "tenant");
}
